<template>
  <v-container
    class="d-flex justify-center align-center flex-column"
    style="height: 80vh; max-width: 600px;"
  >
    <div class="text-h4">
        403 ERROR
    </div>
    <div class="text-h4">
        Access denied
    </div>
    <div class="my-6 text-center">
        <div class="font-weight-light">
            Looks like you don't have access to this page.
        </div>
    </div>
    <v-btn 
        to="/dashboard"
        class="px-10 py-6" 
        color="grey lighten-2"
        elevation="0"
        rounded
        large
    >
      BACK TO HOME
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Page403",
};
</script>
